import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  makeStyles,
  Icon,
  DialogContentText,
  IconButton,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paperWidthXs': {
      padding: '1rem',
    },
  },
  closeIconStyle: {
    display: 'flex',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: 0,
    padding: '2px',
    fontWeight: 'bold',
    color: '#183560',
  },
  titleStyle: {
    color: '#183560',
    fontSize: '18px',
    padding: 0,
    marginBottom: '10px',
  },
  contentTextStyle: {
    color: '#183560',
    fontSize: '16px',
    marginBottom: '20px',
  },
  contentStyle: {
    textAlign: 'center',
  },
}))

const DraftNotificationPopup = ({
  open,
  title,
  body,
  DiscardButton,
  ConfirmButton,
  handleCloseDialog,
  isLoading = false,
  ...rest
}) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      maxWidth="xs"
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ root: classes.root }}
      {...rest}
    >
      <IconButton disabled={isLoading} className={classes.closeIconStyle}>
        <Icon onClick={handleCloseDialog}>close</Icon>
      </IconButton>
      <DialogContent className={classes.contentStyle}>
        <DialogTitle className={classes.titleStyle}>{title}</DialogTitle>
        <DialogContentText className={classes.contentTextStyle}>
          {body}
        </DialogContentText>
        <DialogActions>
          <div className="w-full sm:space-x-5 sm:flex sm:space-y-0 space-y-4 justify-center">
            {DiscardButton}
            {ConfirmButton}
          </div>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default DraftNotificationPopup
